import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  setMobileHelpersData,
  setModalsData,
  TMobileHelpers,
  TModalsState,
} from "../../api/store/commonSlice";
import { useAppMenus } from "../../navigation/dashboardSideMenu";
import svgIcons from "../../assets/svg/svgIcons";
import MenuItemLabel from "./menuItemLabel";

const AdminsDropdown = () => {
  const navigate = useNavigate();
  const { t: tTop } = useTranslation("translation", {
    keyPrefix: "dashboard.top",
  });
  const { t } = useTranslation("translation", {
    keyPrefix: "dashboard.sidemenu",
  });
  const modalsState = useSelector(
    (state: { commonReducer: { modals: TModalsState } }) =>
      state.commonReducer.modals
  );

  // mobile helpers
  const mobileHelpers = useSelector(
    (state: { commonReducer: { mobileHelpers: TMobileHelpers } }) =>
      state.commonReducer.mobileHelpers
  );

  const dispatch = useDispatch();

  const { dashboardAdminsMenuItems } = useAppMenus();

  const toggleAdminsDropdown = (show: boolean) => {
    dispatch(
      setModalsData({
        ...modalsState,
        showNotifications: false,
        showAdminsDropdown: show,
      })
    );
  };

  const hideMobileMenu = () => {
    dispatch(
      setMobileHelpersData({
        ...mobileHelpers,
        showRightMenuDrawer: false,
      })
    );
    dispatch(
      setModalsData({
        ...modalsState,
        showNotifications: false,
        showAdminsDropdown: false,
      })
    );
  };

  return (
    <>
      <div
        className={`fixed top-0 left-0 w-full h-screen z-overlay bg-modal-overlay${modalsState?.showAdminsDropdown ? "" : " hidden"}`}
        onClick={() => toggleAdminsDropdown(false)}
      ></div>
      <div
        className={`relative flex items-center justify-center bg-white rounded-full${modalsState?.showAdminsDropdown ? " z-modal" : ""}`}
      >
        <button
          type="button"
          className="w-full lg:w-auto flex items-center justify-center gap-2 rounded-full min-w-12 h-12 relative"
          title={tTop("admins")}
          onClick={() => toggleAdminsDropdown(!modalsState?.showAdminsDropdown)}
        >
          <img
            src={svgIcons.AdminGearIcon}
            alt="gear-icon"
            className="size-7 translate-x-[2px] ms-5 lg:ms-0"
          />
          {/* <span className="sr-only">Admins Menu</span> */}
          <span className="lg:hidden flex-grow px-2.5 text-left text-accent-blue-bright font-bold">
            {tTop("admins")}
          </span>
          <MenuItemLabel label={tTop("admins")} />
        </button>
        <div
          className={`absolute top-full mt-2 end-0 start-0 lg:start-auto w-full lg:w-56 rounded-md border border-gray-100 bg-white shadow-lg z-modal${modalsState.showAdminsDropdown ? "" : " hidden"}`}
          role="menu"
        >
          <div className="p-2">
            {dashboardAdminsMenuItems.map((item, index) => {
              const title = t(`admins.${item.slug}`);
              return (
                <Link
                  role="menuitem"
                  key={index}
                  to={item.path}
                  onClick={() => {
                    toggleAdminsDropdown(false);
                    if (mobileHelpers.showRightMenuDrawer) {
                      hideMobileMenu();
                    }
                    navigate(item.path);
                  }}
                >
                  <div className="w-full flex gap-3 rounded-lg px-4 py-2 text-sm text-gray-500 hover:bg-gray-200 hover:text-gray-700 cursor-pointer">
                    <img src={item.icon} alt={title} className="size-5" />
                    <span>{title}</span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
export default AdminsDropdown;
